import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CtaBanner() {
  const [ctaData, setCtaData] = useState(null);

  useEffect(() => {
    fetch('/_api/public/content/forside')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (Array.isArray(data) && data[0]) {
          setCtaData(data[0]);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section id="kontakt-cta" className="py-16 lg:py-20 bg-[#646754] text-white relative overflow-hidden scroll-mt-20">
      
      {/* Full-bleed background image with hero matching overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=75,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-friskole-outdoor-nature.jpg"
          alt="Odder Lille Friskole Udeliv"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradient overlay - solid on left / center, clear and low opacity on right */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#646754]/95 via-[#646754]/75 to-[#646754]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#646754]/40 via-transparent to-[#646754]/10" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-6">

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white font-serif-heading">
            {ctaData?.cta_overskrift || "Vil du opleve vores skole i virkeligheden?"}
          </h2>

          <p className="text-base sm:text-lg text-[#D2E4DA] leading-relaxed max-w-2xl mx-auto">
            {ctaData?.cta_tekst || "Kom på et uforpligtende besøg, mærk den varme atmosfære og hør mere om, hvordan vi skaber tryghed, trivsel og stærk faglighed for dit barn."}
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/besoeg-skolen"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-full text-base font-bold text-[#1A3626] bg-[#eef4e6] hover:bg-white hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-200 active:scale-98"
            >
              <i className="fa-regular fa-calendar-check text-sm" aria-hidden="true" />
              <span>Book et skolebesøg</span>
            </Link>

            <Link
              to="/skriv-dit-barn-op"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-full text-base font-bold text-[#1D2923] bg-[#c1d8e5] hover:bg-[#a9c9da] hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-200 active:scale-98"
            >
              <i className="fa-solid fa-pen-nib text-sm" aria-hidden="true" />
              <span>Skriv dit barn op nu</span>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
